import React from "react";
import { Space } from "antd";
import { AxArtwork, AxDivider } from "@dynata/axiom3";

import img404 from "@dynata/axiom3-images/png/general_404.png";
import placeholderOne from "@dynata/axiom3-images/svg/illustration-placeholder-1.svg";
import placeholderTwo from "@dynata/axiom3-images/svg/illustration-placeholder-2.svg";

class Artwork extends React.Component {
  render() {
    return (
      <div className="section" id="artwork">
        <h3>Artwork</h3>
        <Space direction="vertical">
          <p>Artwork component for various states.</p>
        </Space>

        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>

        <Space size="large" direction="vertical">
          <pre>{`<AxArtwork title="Art Title" image={image} />`}</pre>

          <p className="props-title">Props</p>
          <table className="props-table">
            <tbody>
              <tr>
                <th>Property</th>
                <th>Description</th>
                <th>Value</th>
              </tr>
              <tr>
                <td>title</td>
                <td>Title of Artwork template</td>
                <td>string</td>
              </tr>
              <tr>
                <td>image</td>
                <td>Image to be used</td>
                <td>ReactNode</td>
              </tr>
              <tr>
                <td>description</td>
                <td>Additional content of Artwork template</td>
                <td>ReactNode</td>
              </tr>
              <tr>
                <td>button</td>
                <td>Button text</td>
                <td>ReactNode</td>
              </tr>
              <tr>
                <td>href</td>
                <td>Redirect url of button</td>
                <td>string</td>
              </tr>
              <tr>
                <td>target</td>
                <td>target attribute of a, works when href is specified</td>
                <td>string</td>
              </tr>
            </tbody>
          </table>
        </Space>

        <AxDivider orientation="left" plain>
          Not Found | Check Back Later | Error | Maintenance | Unauthorized
        </AxDivider>

        <Space size="large" direction="vertical">
          <pre>{`
import img404 from "@dynata/axiom3-images/png/general_404.png";
import placeholderOne from "@dynata/axiom3-images/svg/illustration-placeholder-1.svg";
import placeholderTwo from "@dynata/axiom3-images/svg/illustration-placeholder-2.svg";
          
<AxArtwork
  title="Page Not Found"
  image={img404}
  description="Sorry, we can't find the page you're looking for."
  button="Return to Home Page"
  href="http://google.com"
  target="_blank"
/>

<AxArtwork
  title="Please Check Back Later"
  image={imgStand}
  description="This page is unavailable at the moment."
  button="Return to Home Page"
  href="http://google.com"
  target="_blank"
/>

<AxArtwork
  title="An Error Has Occured"
  image={imgError}
  description="Error Details"
  button="Return to Home Page"
  href="http://google.com"
  target="_blank"
/>

<AxArtwork
  title="We're Down For Maintenance"
  image={imgDown}
  description="We're currently undergoing maintenance. Please check back later."
  button="Return to Home Page"
  href="http://google.com"
  target="_blank"
/>

<AxArtwork
  title="Unauthorized Access"
  image={imgUnauthorized}
  description="It looks like you don't have the permission to access this page."
  button="Return to Home Page"
  href="http://google.com"
  target="_blank"
/>

<AxArtwork title="Placeholder One" image={placeholderOne} />

<AxArtwork title="Placeholder Two" image={placeholderTwo} />
`}</pre>
          <Space direction="vertical">
            <AxArtwork
              title="Page Not Found"
              image={img404}
              description="Sorry, we can't find the page you're looking for."
              button="Return to Home Page"
              href="http://google.com"
              target="_blank"
            />

            <AxArtwork description="Placeholder One" image={placeholderOne} />

            <AxArtwork description="Placeholder Two" image={placeholderTwo} />
          </Space>
        </Space>
      </div>
    );
  }
}
export default Artwork;
